App.service('authService', function($api, $rootScope, $cookies, $location, $state, $http, $timeout, USER_TYPES, SERVER_BASE_AUTH_URL, authServiceHelpers, OAuth){
  return {
    // SameSite=Lax comes from $cookiesProvider.defaults (app.init.js).
    setCookie(cookie_hash, expireDate) {
      const isSecure = window.location.protocol === 'https:'
      for (const key in cookie_hash) {
        const value = cookie_hash[key]
        if (expireDate) {
          $cookies.put(key, value, { 'expires': expireDate, 'secure': isSecure })
        } else {
          $cookies.put(key, value, { 'secure': isSecure })
        }
      }
    },
    storeOAuthToken(accessToken, tokenType, expiresInSeconds, impersonated) {
      const date = new Date()
      date.setTime(date.getTime() + expiresInSeconds * 1000)
      this.setCookie({ 'auth': accessToken }, date)
      this.setCookie({ 'oauth.token_type': tokenType }, date)
      if (impersonated) {
        $rootScope.impersonated = true
        this.setCookie({ 'impersonated': true }, date)
      }
    },
    // "impersonationSessionId" used for backward compatibility with the old backend. should be removed once we use Auth::Token for auth
    willAuthorizeUser(user, uid_hash, subdomain, institution, remember_token, location_id, impersonationSessionId = null) {
      let cookies = [
        { 'userType': user.meta_type },
        { 'provider_id': user.id },
        { 'name': user.name },
        { 'subdomain': subdomain },
        { 'image': user.profile_url },
        { 'min_appt_length': user.min_appt_length },
        { 'patientable': user.patientable },
        { 'email': user.email },
        { 'userCreatedAt': user.created_at }
      ]
      if (location_id) {
        cookies.push({ 'location_id': location_id })
      }
      if ([undefined, 'undefined', 'null'].includes($cookies.get('uid_hash'))) {
        cookies.push({ uid_hash: uid_hash })
      }
      if (remember_token) {
        cookies.push({ 'auth': remember_token })
      }
      if (institution) {
        cookies.push({ 'institution_id': institution.id })
      }
      if (impersonationSessionId) {
        $rootScope.impersonationSessionId = impersonationSessionId
        cookies.push({ impersonationSessionId: impersonationSessionId })
      }
      let expireDate = null
      if (this.impersonated()) {
        expireDate = new Date()
        expireDate.setHours(expireDate.getHours() + 4)
      }
      cookies.forEach(cookie_hash => {
        this.setCookie(cookie_hash, expireDate)
      })
      $rootScope.remember_token = remember_token
      $rootScope.subdomain = subdomain
      this.registerHeap()
    },
    removeCookies() {
      $cookies.remove('auth')
      $cookies.remove('userType')
      $cookies.remove('provider_id')
      $cookies.remove('uid_hash')
      $cookies.remove('name')
      $cookies.remove('subdomain')
      $cookies.remove('image')
      $cookies.remove('min_appt_length')
      $cookies.remove('patientable')
      $cookies.remove('email')
      $cookies.remove('location_id')
      $cookies.remove('userCreatedAt')
      $cookies.remove('open_mfa_reminder')
      $cookies.remove('institution_id')
      $cookies.remove('impersonationSessionId')
      $cookies.remove('impersonated')
      $cookies.remove('email')
      $cookies.remove('oauth.token_type')
      $cookies.remove('oauth.state')
      $cookies.put('image')
      $rootScope.impersonationSessionId = undefined
      $rootScope.remember_token = undefined
      $rootScope.subdomain = undefined
    },
    cleanLocalStorage() {
      $rootScope.$storage.removeItem('apptBookingData')
    },
    willUnauthorizeUser(from_intake_page = false) {
      // `from_intake_page` purpose - identify that request is initially done from the appt booking page; show a simple form of the maintenance page in that case
      lg("Unauthorizing user...")
      const redirectAfterLogoutUrl = `${SERVER_BASE_AUTH_URL}/logout?redirect_url=${encodeURIComponent(window.location.href)}`;
      if (this.isAuthenticatedWithOAuth()) {
        OAuth.revoke(this.getAuth())
      } else {
        $api('DELETE', '/authenticates/0', { impersonation_session_id: this.impersonationSessionId(), from_intake_page: from_intake_page })
      }

      // The practice app's own BroadcastChannel in this tab receives this too and would reload,
      // cancelling the caller's logout redirect. Mark the tab so it ignores session_updated until it unloads.
      window.NH_SESSION_SYNC_ORIGIN = true
      const broadcastChannel = new BroadcastChannel("session_sync");
      broadcastChannel.postMessage("session_updated")

      this.removeCookies()
      if (!from_intake_page) this.cleanLocalStorage()

      return { redirectAfterLogoutUrl }
    },
    willRouteByUserType(currentState) {
      if (this.getUserType() === 'Patient') {
        return $state.go(currentState += '.patient')
      }
      else if (this.getUserType() === 'Doctor' || this.getUserType() === 'Nurse') {
        return $state.go(currentState += '.doctor')
      }
      else {
        return state.go(currentState)
      }
    },
    registerHeap() {
      if(!heap || heap.loaded) return
      if($rootScope.impersonated) return
      if (window.location.hostname.indexOf('app.nexhealth.com') != -1) {
        heap.load("3664786524");
      } else {
        heap.load("3293928091");
      }

      if($cookies.get("provider_id")) {
        heap.identify($cookies.get("provider_id"))
      }

      if (
        $cookies.get("provider_id") &&
        $cookies.get("name") &&
        $cookies.get("email") &&
        $cookies.get("userType") &&
        $cookies.get("institution_id") &&
        $cookies.get("subdomain")
      ) {
        heap.addUserProperties({
          Id: $cookies.get("provider_id"),
          Name: $cookies.get("name"),
          email: $cookies.get("email"),
          Role: $cookies.get("userType"),
          InstitutionId: $cookies.get("institution_id"),
          InstitutionSlug: $cookies.get("subdomain")
        });
      }

      if (
        $cookies.get("location_id") &&
        $cookies.get("institution_id") &&
        $cookies.get("subdomain")
      ) {
        heap.clearEventProperties();
        heap.addEventProperties({
          InstitutionId: $cookies.get("institution_id"),
          InstitutionSlug: $cookies.get("subdomain"),
          LocationId: $cookies.get("location_id")
       });
      }
    },
    isDoctor: authServiceHelpers.isDoctor,
    isRN: authServiceHelpers.isRN,
    isNP: authServiceHelpers.isNP,
    isPA: authServiceHelpers.isPA,
    isMA: authServiceHelpers.isMA,
    isStaff: authServiceHelpers.isStaff,
    isUserAuthorized: authServiceHelpers.isUserAuthorized,
    isPatientable: authServiceHelpers.isPatientable,
    getUserAuthorization: authServiceHelpers.getUserAuthorization,
    getUserAuthorizationHeader: authServiceHelpers.getUserAuthorizationHeader,
    getAuth: authServiceHelpers.getAuth,
    getTokenType: authServiceHelpers.getTokenType,
    getUserType: authServiceHelpers.getUserType,
    getUserId: authServiceHelpers.getUserId,
    getMinApptLength: authServiceHelpers.getMinApptLength,
    getInstitutionId: authServiceHelpers.getInstitutionId,
    getUserSubdomain: authServiceHelpers.getUserSubdomain,
    getUserName: authServiceHelpers.getUserName,
    getUserEmail: authServiceHelpers.getUserEmail,
    getUserImageUrl: authServiceHelpers.getUserImageUrl,
    getLocationId: authServiceHelpers.getLocationId,
    impersonated: authServiceHelpers.impersonated,
    impersonationSessionId: authServiceHelpers.impersonationSessionId,
    isAuthenticatedWithOAuth: authServiceHelpers.isAuthenticatedWithOAuth,
    isProvider: authServiceHelpers.isProvider,
    isStaffOrNurse: authServiceHelpers.isStaffOrNurse
}})
